import React, {useContext} from 'react';
import {ActivityContext} from '../../index';
import styles from '../../index.module.scss';
import CONSTANTS from '../../constant';

function ActivityEffect() {
  const { task } = useContext(ActivityContext);
  return (
    <div className={styles['cardBox']}>
      <div className={styles['titleBox']}>活动作用：</div>
      {CONSTANTS.ACTIVITY_TYPE_DATA[task].activityEffectText}
    </div>
  );
}

export default ActivityEffect;
